var map = {
	"./Avatar Sprite-0.png": 4860,
	"./Avatar Sprite-1.png": 42632,
	"./Avatar Sprite-10.png": 50735,
	"./Avatar Sprite-100.png": 83604,
	"./Avatar Sprite-101.png": 57584,
	"./Avatar Sprite-102.png": 56592,
	"./Avatar Sprite-103.png": 52316,
	"./Avatar Sprite-104.png": 41252,
	"./Avatar Sprite-105.png": 12244,
	"./Avatar Sprite-106.png": 98844,
	"./Avatar Sprite-107.png": 87508,
	"./Avatar Sprite-108.png": 4484,
	"./Avatar Sprite-109.png": 23656,
	"./Avatar Sprite-11.png": 73348,
	"./Avatar Sprite-110.png": 2916,
	"./Avatar Sprite-111.png": 38356,
	"./Avatar Sprite-112.png": 33204,
	"./Avatar Sprite-113.png": 296,
	"./Avatar Sprite-114.png": 1888,
	"./Avatar Sprite-115.png": 90944,
	"./Avatar Sprite-116.png": 59572,
	"./Avatar Sprite-117.png": 50660,
	"./Avatar Sprite-118.png": 46544,
	"./Avatar Sprite-12.png": 70820,
	"./Avatar Sprite-13.png": 35772,
	"./Avatar Sprite-14.png": 89040,
	"./Avatar Sprite-15.png": 70068,
	"./Avatar Sprite-16.png": 26572,
	"./Avatar Sprite-17.png": 95412,
	"./Avatar Sprite-18.png": 59204,
	"./Avatar Sprite-19.png": 24052,
	"./Avatar Sprite-2.png": 21000,
	"./Avatar Sprite-20.png": 83948,
	"./Avatar Sprite-21.png": 56968,
	"./Avatar Sprite-22.png": 55292,
	"./Avatar Sprite-23.png": 34288,
	"./Avatar Sprite-24.png": 80956,
	"./Avatar Sprite-25.png": 78420,
	"./Avatar Sprite-26.png": 58140,
	"./Avatar Sprite-27.png": 68024,
	"./Avatar Sprite-28.png": 90196,
	"./Avatar Sprite-29.png": 1116,
	"./Avatar Sprite-3.png": 27728,
	"./Avatar Sprite-30.png": 71188,
	"./Avatar Sprite-31.png": 1568,
	"./Avatar Sprite-32.png": 98052,
	"./Avatar Sprite-33.png": 26348,
	"./Avatar Sprite-34.png": 53868,
	"./Avatar Sprite-35.png": 38476,
	"./Avatar Sprite-36.png": 68196,
	"./Avatar Sprite-37.png": 12668,
	"./Avatar Sprite-38.png": 3876,
	"./Avatar Sprite-39.png": 12788,
	"./Avatar Sprite-4.png": 68612,
	"./Avatar Sprite-40.png": 48140,
	"./Avatar Sprite-41.png": 57344,
	"./Avatar Sprite-42.png": 22332,
	"./Avatar Sprite-43.png": 21081,
	"./Avatar Sprite-44.png": 11232,
	"./Avatar Sprite-45.png": 80852,
	"./Avatar Sprite-46.png": 36012,
	"./Avatar Sprite-47.png": 7716,
	"./Avatar Sprite-48.png": 8744,
	"./Avatar Sprite-49.png": 53704,
	"./Avatar Sprite-5.png": 10607,
	"./Avatar Sprite-50.png": 35380,
	"./Avatar Sprite-51.png": 65344,
	"./Avatar Sprite-52.png": 33040,
	"./Avatar Sprite-53.png": 34748,
	"./Avatar Sprite-54.png": 66120,
	"./Avatar Sprite-55.png": 89736,
	"./Avatar Sprite-56.png": 18884,
	"./Avatar Sprite-57.png": 27324,
	"./Avatar Sprite-58.png": 68068,
	"./Avatar Sprite-59.png": 18708,
	"./Avatar Sprite-6.png": 14880,
	"./Avatar Sprite-60.png": 43492,
	"./Avatar Sprite-61.png": 79448,
	"./Avatar Sprite-62.png": 4928,
	"./Avatar Sprite-63.png": 16936,
	"./Avatar Sprite-64.png": 75664,
	"./Avatar Sprite-65.png": 97124,
	"./Avatar Sprite-66.png": 26060,
	"./Avatar Sprite-67.png": 68396,
	"./Avatar Sprite-68.png": 54240,
	"./Avatar Sprite-69.png": 88524,
	"./Avatar Sprite-7.png": 82108,
	"./Avatar Sprite-70.png": 70564,
	"./Avatar Sprite-71.png": 83392,
	"./Avatar Sprite-72.png": 46928,
	"./Avatar Sprite-73.png": 86004,
	"./Avatar Sprite-74.png": 29592,
	"./Avatar Sprite-75.png": 47600,
	"./Avatar Sprite-76.png": 9612,
	"./Avatar Sprite-77.png": 81436,
	"./Avatar Sprite-78.png": 39940,
	"./Avatar Sprite-79.png": 87039,
	"./Avatar Sprite-8.png": 77520,
	"./Avatar Sprite-80.png": 92504,
	"./Avatar Sprite-81.png": 96844,
	"./Avatar Sprite-82.png": 74796,
	"./Avatar Sprite-83.png": 7380,
	"./Avatar Sprite-84.png": 65735,
	"./Avatar Sprite-85.png": 84524,
	"./Avatar Sprite-86.png": 39152,
	"./Avatar Sprite-87.png": 67844,
	"./Avatar Sprite-88.png": 50132,
	"./Avatar Sprite-89.png": 12040,
	"./Avatar Sprite-9.png": 16856,
	"./Avatar Sprite-90.png": 68756,
	"./Avatar Sprite-91.png": 71292,
	"./Avatar Sprite-92.png": 80740,
	"./Avatar Sprite-93.png": 48476,
	"./Avatar Sprite-94.png": 24924,
	"./Avatar Sprite-95.png": 51904,
	"./Avatar Sprite-96.png": 24624,
	"./Avatar Sprite-97.png": 23248,
	"./Avatar Sprite-98.png": 49200,
	"./Avatar Sprite-99.png": 44924
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69744;